import { render, staticRenderFns } from "./threejs7.vue?vue&type=template&id=327d5da2&scoped=true"
import script from "./threejs7.vue?vue&type=script&lang=js"
export * from "./threejs7.vue?vue&type=script&lang=js"
import style0 from "./threejs7.vue?vue&type=style&index=0&id=327d5da2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "327d5da2",
  null
  
)

export default component.exports